module.exports = __webpack_public_path__ + "img/tomb-stone.3c1fff5a.svg";